import currency from "../../img/image-currency.jpg";
import restaurant from "../../img/image-restaurant.jpg";
import plane from "../../img/image-plane.jpg";
import confetti from "../../img/image-confetti.jpg";

export const articlesLists = [
    {
        id: 1,
        img: currency,
        author: "By Claire Robinson",
        title: "Receive money in any currency with no fees",
        text: "The world is getting smaller and we’re becoming more mobile. So why should you be forced to only receive money in a single …",
    },
    {
        id: 2,
        img: restaurant,
        author: "By Wilson Hutton",
        title: "Treat yourself without worrying about money",
        text: "Our simple budgeting feature allows you to separate out your spending and set realistic limits each month. That means you …",
    },
    {
        id: 3,
        img: plane,
        author: "By Wilson Hutton",
        title: "Take your Easybank card wherever you go",
        text: "We want you to enjoy your travels. This is why we don’t charge any fees on purchases while you’re abroad. We’ll even show you …",
    },
    {
        id: 4,
        img: confetti,
        author: "By Claire Robinson",
        title: "Our invite-only Beta accounts are now live!",
        text: "After a lot of hard work by the whole team, we’re excited to launch our closed beta. It’s easy to request an invite through the site ...",
    },
];
